module.exports = __webpack_public_path__ + "img/ARCH_06_prew.33214e83.jpg";